import React, { useState } from 'react';
import styles from './SupportGallery.module.css';

const SupportGallery = ({ gallery }) => {
    const [imagesError, setImagesError] = useState({});
    const [selectedImage, setSelectedImage] = useState(null);

    if (!gallery || gallery.length === 0) {
        return (
            <section className={styles.section}>
                <h3>Galería de apoyo <span className={styles.optional}>(opcional)</span></h3>
                <div className={styles.galleryEmpty}>
                    <p>No hay imágenes en la galería</p>
                </div>
            </section>
        );
    }

    const getValidImageSrc = (imageUrl) => {
        if (!imageUrl || imagesError[imageUrl]) {
            return null;
        }

        let rawSrc = imageUrl;
        if (typeof imageUrl === 'object') {
            rawSrc = imageUrl.url || imageUrl.src || imageUrl.image || JSON.stringify(imageUrl);
        }

        if (!rawSrc) return null;

        if (rawSrc.startsWith('data:image/')) {
            return rawSrc;
        }

        if (rawSrc.startsWith('/9j/')) {
            return `data:image/jpeg;base64,${rawSrc}`;
        }

        if (rawSrc.startsWith('iVBOR')) {
            return `data:image/png;base64,${rawSrc}`;
        }

        if (rawSrc.match(/^[A-Za-z0-9+/=]+$/)) {
            return `data:image/jpeg;base64,${rawSrc}`;
        }

        if (rawSrc.startsWith('http://') || rawSrc.startsWith('https://')) {
            return rawSrc;
        }

        if (rawSrc.startsWith('/')) {
            return rawSrc;
        }

        return rawSrc;
    };

    const handleImageError = (imageUrl) => {
        setImagesError(prev => ({ ...prev, [imageUrl]: true }));
    };

    return (
        <>
            <section className={styles.section}>
                <h3>Galería de apoyo <span className={styles.optional}>(opcional)</span></h3>
                <div className={styles.gallery}>
                    {gallery.map((item, index) => {
                        const imageUrl = typeof item === 'string' ? item : (item.url || item.src || item.image);
                        const validSrc = getValidImageSrc(imageUrl);

                        return (
                            <div
                                className={styles.galleryItem}
                                key={index}
                                onClick={() => validSrc && setSelectedImage(validSrc)}
                            >
                                {validSrc ? (
                                    <img
                                        src={validSrc}
                                        alt={`Galería ${index + 1}`}
                                        className={styles.galleryImage}
                                        onError={() => handleImageError(imageUrl)}
                                        loading="lazy"
                                    />
                                ) : (
                                    <div className={styles.galleryPlaceholder}>
                                        <span>📷</span>
                                        <small>Imagen {index + 1}</small>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </section>

            {selectedImage && (
                <div className={styles.galleryModal} onClick={() => setSelectedImage(null)}>
                    <button
                        className={styles.galleryModalClose}
                        onClick={() => setSelectedImage(null)}
                        aria-label="Cerrar"
                    >
                        ✕
                    </button>
                    <img
                        src={selectedImage}
                        alt="Ampliada"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </>
    );
};

export default SupportGallery;